import { StyleSheet } from "react-native"

export const styles = StyleSheet.create({
  ClickableBackground: {
    position: "absolute",
    left: 0,
    top: 0,
  },
})
